import { render, staticRenderFns } from "./MarketValue.vue?vue&type=template&id=b660c764&scoped=true&"
import script from "./MarketValue.vue?vue&type=script&lang=js&"
export * from "./MarketValue.vue?vue&type=script&lang=js&"
import style0 from "./MarketValue.vue?vue&type=style&index=0&id=b660c764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b660c764",
  null
  
)

export default component.exports